var map = {
	"./amex.svg": "0e9b",
	"./card.svg": "e84d",
	"./diners.svg": "8c3d",
	"./discover.svg": "7758",
	"./jcb.svg": "54c5",
	"./mastercard.svg": "1f07",
	"./unionpay.svg": "ee6b",
	"./visa.svg": "a737"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bdb9";